(function () {
    "use strict";

    angular.module("app").directive("isTabActive", IsTabActiveDirective);

    IsTabActiveDirective.$inject = ["$parse", "tabNavigationService", "HABIL_EVENTS"];
    function IsTabActiveDirective($parse, tabNavigationService, HABIL_EVENTS) {
        return {
            restrict: 'A',
            multiElement: true,
            link: function (scope, element, attr) {

                const tab = {
                    Name: attr.isTabActive,
                    ShouldInit: false,
                    Init: angular.noop
                };

                tab.Name = attr.isTabActive;
                try {
                    if (attr.onFirstRender) {
                        tab.Init = $parse(attr.onFirstRender);
                        tab.ShouldInit = true;
                    }
                }
                catch {
                    // Avoid breaking the directive when no initialize function is added
                }

                if (!tabNavigationService.IsActive(tab.Name))
                    element.addClass("ng-hide");

                scope.$on(HABIL_EVENTS.navigation.tabChanged, function() {
                    const isActive = tabNavigationService.IsActive(tab.Name);

                    if (isActive && tab.ShouldInit) {
                        tab.ShouldInit = false;
                        tab.Init(scope);
                    }                        

                    element[isActive ? "removeClass" : "addClass"]("ng-hide");
                });
            }
        };
    }
})();